import React from 'react';

function Articles() {

  return (
    <section className="bg-neutral-100 px-4 py-5 lg:pr-48">
        <div className="bg-white border border-neutral-300 max-w-screen-md px-4 py-8 mx-auto mt-20">
            <h2 className="text-xl lg:text-2xl pb-1 font-semibold">Articles  have written</h2>

            <div className="flow-root mt-2">
                <div className="divide-y divide-gray--200 -my-1">
                    <div className="py-2">
                        <p className="text-xl font-semibold text-black">The best and shortest way to debug your code.</p>
                        <p className="mt-3 text-base text-gray-600">
                            The article outlines different approaches to debugging such as using documentation, 
                            Google, logging, testing, and static analysis/types and linters. By following these strategies, 
                            developers can reduce defects and bugs in their programs, making debugging less difficult and even enjoyable.
                        </p>
                        <a href="https://medium.com/@barakadan421/the-best-and-shortest-way-to-debug-your-code-2e9a46888b04" target="_blank" rel="noreferrer" className="text-blue-600 transition-all duration-200 hover:text-blue-700 focus:text-blue-700 hover:underline">Read article...</a>
                    </div>

                    <div className="py-2">
                        <p className="text-xl font-semibold text-black">How to Learn programming fast</p>
                        <p className="mt-3 text-base text-gray-600">
                        The article provides helpful tips for learning programming, emphasizing the importance of hard work, 
                        determination, and willingness to learn. The author suggests starting with the basics, building projects to practice, 
                        and being consistent in daily learning. By following these steps, the author believes anyone can become a competent and reliable programmer.
                        </p>
                        <a href="https://medium.com/@barakadan421/how-to-learn-programming-fast-25b8e9ee5c7" target="_blank" rel="noreferrer" className="text-blue-600 transition-all duration-200 hover:text-blue-700 focus:text-blue-700 hover:underline">Read article...</a>
                    </div>
                </div>
            </div>
        </div>
    </section>


  );
}

export default Articles;
